import React, { useEffect, useState } from 'react'
import {
  AiDataExtractionAnalyzingModal,
  AiDataExtractionAnalyzingModalProps,
  ProcessingState,
} from './AiDataExtractionAnalyzingModal'

const NEXT_SUCCESS_FLOW_STATE: Partial<Record<ProcessingState, ProcessingState>> = {
  [ProcessingState.Preparing]: ProcessingState.Analyzing,
  [ProcessingState.Analyzing]: ProcessingState.Transferring,
  [ProcessingState.Transferring]: ProcessingState.Completing,
  [ProcessingState.Completing]: ProcessingState.Done,
}

const STEP_DURATION_MS = 2000
const SUCCESS_CLOSE_DELAY_MS = 1000

interface AiDataExtractionAnalyzingModalMockProps extends AiDataExtractionAnalyzingModalProps {
  onFinished?: () => void
}

export const AiDataExtractionAnalyzingModalMock = ({
  visible,
  state,
  onRetry,
  onFinished,
}: AiDataExtractionAnalyzingModalMockProps) => {
  const [currentState, setCurrentState] = useState(state)
  const [isModalVisible, setIsModalVisible] = useState(visible)

  useEffect(() => {
    if (!visible) {
      setCurrentState(state)
      setIsModalVisible(false)
      return
    }

    setIsModalVisible(true)

    if (state === ProcessingState.Error) {
      setCurrentState(ProcessingState.Error)
      return
    }

    setCurrentState(state)
  }, [visible, state])

  useEffect(() => {
    if (!visible || currentState === ProcessingState.Error || currentState === ProcessingState.Done) {
      return
    }

    const nextState = NEXT_SUCCESS_FLOW_STATE[currentState] as ProcessingState

    const timeoutId = window.setTimeout(() => {
      setCurrentState(nextState)
    }, STEP_DURATION_MS)

    return () => window.clearTimeout(timeoutId)
  }, [currentState, visible])

  useEffect(() => {
    if (!visible || currentState !== ProcessingState.Done) {
      return
    }

    const timeoutId = window.setTimeout(() => {
      setIsModalVisible(false)
      onFinished?.()
    }, SUCCESS_CLOSE_DELAY_MS)

    return () => window.clearTimeout(timeoutId)
  }, [currentState, onFinished, visible])

  const handleRetry = () => {
    setCurrentState(ProcessingState.Preparing)
    setIsModalVisible(true)
    onRetry?.()
  }

  return <AiDataExtractionAnalyzingModal visible={isModalVisible} state={currentState} onRetry={handleRetry} />
}
